import MarketingNav from './MarketingNav';
import MarketingFooter from './MarketingFooter';

export default function MarketingAbout() {
  return (
    <div className="bg-[#F0F9FF] min-h-screen flex flex-col">
      <MarketingNav />

      <section className="bg-[#0A2540] text-white py-16 px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold mb-4">Our mission</h1>
          <p className="text-slate-300 text-lg">
            We're building the AI infrastructure for African healthcare.
          </p>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-3xl mx-auto space-y-16">
          {/* The problem */}
          <div>
            <h2 className="text-2xl font-bold text-[#0A2540] mb-4">The problem we're solving</h2>
            <p className="text-[#64748B] leading-relaxed mb-4">
              Across West Africa, doctors spend an average of 30–50% of their working hours on administrative documentation — writing notes, completing forms, and generating reports. This time is stolen from patients.
            </p>
            <p className="text-[#64748B] leading-relaxed">
              Meanwhile, healthcare facilities struggle with fragmented operations — disconnected scheduling, pharmacy, and bed management systems that create inefficiency and risk. Scrivera is built to fix both.
            </p>
          </div>

          {/* What Scrivera does */}
          <div>
            <h2 className="text-2xl font-bold text-[#0A2540] mb-4">What Scrivera does</h2>
            <p className="text-[#64748B] leading-relaxed mb-4">
              Scrivera listens to doctor-patient consultations and instantly generates structured clinical documentation — SOAP notes, referral letters, and discharge summaries — freeing clinicians to focus entirely on the patient in front of them.
            </p>
            <p className="text-[#64748B] leading-relaxed">
              Our operations module brings scheduling, bed management, pharmacy, and supply chain into a single, AI-assisted dashboard — designed for how African hospitals actually work, including offline-first and on-premise deployments.
            </p>
          </div>

          {/* Founding team */}
          <div>
            <h2 className="text-2xl font-bold text-[#0A2540] mb-6">Founding team</h2>
            <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm">
              <p className="text-[#64748B] text-sm italic">
                Founding team profiles coming soon.
              </p>
            </div>
          </div>

          {/* Darrel Technologies */}
          <div className="bg-[#0A2540] text-white rounded-2xl p-8 text-center">
            <p className="text-sm text-slate-400 uppercase tracking-wider mb-2">Incubated by</p>
            <h3 className="text-xl font-bold mb-2">Darrel Technologies Ltd</h3>
            <p className="text-slate-300 text-sm">
              A technology company incorporated in Ghana, building digital infrastructure for Africa.
            </p>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
